import Vue from 'vue'
import Vuex from 'vuex'

import bank from './modules/bank-module'
import requests from "@/store/modules/requests";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading : false,
    isUpdateAvailable: false,
  },
  getters: {
    getLoadingState : (state) => state.loading,
    getUpdateAvailability: (state) => state.isUpdateAvailable,
  },
  mutations: {
    setLoadingState : (state , payload) => state.loading = payload,
    setUpdateAvailability : (state , payload) => state.isUpdateAvailable = payload,
  },
  actions: {
    refreshState : (context) => {
      $utils.showLoading();
      return Promise.all([
        context.dispatch(`getAllBanks`)
      ]).finally(()=>$utils.hideLoading())
    }
  },
  modules: { bank , requests }
})
